/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FeedbackHelpful } from "@simplicitycms/simplicity-forms";
import { CalendarFeedFilter } from "cms/shared/feeds/calendar";
import { FeatureFlagGuard } from "../cms/features/feature-flag-guard";

const Events = () => {

    return (
        <main>
            <h1 style={{ marginTop: "16px" }}>Events</h1>
            <>
                <div>
                    <CalendarFeedFilter />
                </div>
            </>
            <FeatureFlagGuard feature="feature_was_helpful" >
                <FeedbackHelpful />
            </FeatureFlagGuard>

        </main>
    );
};


export { Events };
